<template>
  <v-app id="inspire" class="portal-main">
    <v-container>
      <header-nav @set-drawer="drawer = !drawer"/>
      <mobile-drawer v-if="$vuetify.breakpoint.mdAndDown" :drawer="drawer" @close="drawer = false"/>
    </v-container>

    <v-main>
      <notification/>
      <router-view :key="$route.fullPath"/>
    </v-main>

    <!-- global overlay -->
    <v-overlay :value="$store.state.common.globalOverlay" class="align-center justify-center">
      <v-progress-circular color="primary" indeterminate size="64"/>
    </v-overlay>
  </v-app>
</template>

<script>
import store from '@/store';
import { initCommonData } from '@/main';
import HeaderNav from '@/components/HeaderNav.vue';
import MobileDrawer from '@/components/MobileDrawer';
import Notification from '@/components/Notification.vue';

export default {
  name: 'App',

  components: {
    HeaderNav,
    MobileDrawer,
    Notification
  },

  data() {
    return {
      drawer: false
    };
  },

  created() {
    initCommonData(store);
  },

  mounted() {
    document.title = 'Pulverit ' + this.$t('app.title');
  }
};
</script>

<style>
/* main */
html {
  background-color: RGB(236, 236, 236);
}

.portal-main {
  background-color: RGB(236, 236, 236) !important;
}

/* menu */

.portal-menu-title {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: RGB(236, 236, 236);
  cursor: default;
}

.portal-menu .v-list-group__header {
  border-top: 1px SOLID white;
  border-bottom: 1px SOLID;
}

.portal-menu-item {
  padding-left: 25px !important;
}

/* detail */

.portal-detail-header {
  position: sticky;
  top: 0;
  background-color: #424242;
  color: white !important;
  box-shadow: 0 6px 10px 0 rgb(0 0 0 / 20%);
  z-index: 100;
}

.portal-detail-header .v-btn > .v-btn__content .v-icon {
  color: white;
}

/* table */

.portal-table-container {
  display: flex;
  justify-content: center
}

.portal-table {
  width: 100%;
  margin: 0 10px;
  text-align: left;
}

.portal-table-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: RGB(236, 236, 236);
  height: 220px;
}

.portal-table-header-title {
  background-color: #424242;
  color: white !important;
  box-shadow: 0 5px 10px 0 rgb(0 0 0 / 20%);
}

.portal-table-header-title select {
  color: white !important;
}

.portal-table-header th {
  padding: 10px 5px;
  font-size: smaller;
}

.portal-table-header .title-el h1 {
  height: 80px;
  margin: -16px;
  padding: 20px;
  background-color: #424242;
  font-size: 1.75rem !important;
}

.portal-table-header .recap {
  height: 80px;
  text-align: center;
  font-size: 12px !important;
  font-weight: normal;
  cursor: default;
  vertical-align: bottom;
}

.portal-table-header .recap select {
  text-decoration: underline;
  cursor: pointer;
  outline: none;
}

.portal-table-header .recap-el {
  height: 80px;
  padding-top: 10px;
  margin: -16px -16px -10px 0;
  background-color: #424242;
}

.portal-table-header .search {
  text-align: center;
}

.portal-table-header .v-pagination__navigation,
.portal-table-header .v-pagination__item {
  min-width: 30px;
  width: 30px;
  max-width: 30px;
  min-height: 30px;
  height: 30px;
  max-height: 30px;
}

.portal-table-header .filters .v-label,
.portal-table-header .filters .v-input {
  font-size: 12px !important;
  font-weight: normal;
}

.portal-table-header .filters .date-picker {
  min-width: 140px;
}

.portal-table-header .sortable-container {
  height: 20px;
}

.portal-table-header .sortable {
  border: 1px solid rgba(211, 211, 211, 0.90);
  font-size: 12px !important;
  font-weight: normal;
  text-align: center;
  cursor: pointer;
}

.portal-table-header .sortable.sorted {
  background-color: rgba(211, 211, 211, 0.80);
}

.portal-table-body tr {
  font-size: 12px;
  background-color: white;
  cursor: default;
}

.portal-table-body tr:hover {
  background-color: #DDDDDD;
  cursor: pointer;
}

.portal-table-body td {
  padding: 10px 5px;
  border-left: thin solid rgba(0, 0, 0, 0.12);
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.portal-table-body-no-results tr {
  font-size: 20px;
  background: none;
}

.portal-table-body-no-results td {
  padding: 0;
  border: none;
  text-align: center;
}

.portal-table-body-no-results .no-result-container {
  margin-left: 30%;
}

.portal-table-body-no-results .v-card {
  padding: 30px 0 25px 0;
  margin-top: 40px;
}
</style>
